import Split from 'react-split';
import styled from 'styled-components';
import { BorderColor } from '../../styles/global/css/Utils';

const Splitter = styled(Split)<{ ishidden?: string }>`
	.gutter {
	    background-color: ${BorderColor};
	    background-repeat: no-repeat;
	    background-position: 50%;
	}

	.gutter.gutter-vertical {
		${p => p.ishidden === 'true' ? 'visibility: hidden;' : ''}
	    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAFAQMAAABo7865AAAABlBMVEVHcEzMzMzyAv2sAAAAAXRSTlMAQObYZgAAABBJREFUeF5jOAMEEAIEEFwAn3kMwcB6I2AAAAAASUVORK5CYII=');
	    cursor: row-resize;
	}
`;

export default Splitter;